<template>
    <a class="gcu-container" :href="link" target="_blank">{{ $t("general.GCU") }}</a>
</template>

<script lang="ts">
export default {
    name: "GcuLink",
    data() {
        return {};
    },
    computed: {
        link() {
            return (
                "https://ar-go.co/" + this.$i18n.locale + "/stqr-conditions-generales-dutilisation/"
            );
        }
    }
};
</script>
<style scoped>
.gcu-container {
    text-decoration: underline;
    color: var(--screenTextColor);
    font-size: 0.85em;
}
</style>
